import {
  buildAuthSessionInvalidation,
  getPageAuthSession,
  getAuthToken,
  invalidatePageAuthSession,
  isStoredSessionTokenCurrent,
  notifyInvalidSession,
  publishAuthSessionInvalidation,
} from './auth';

const toHeaders = (headers) => {
  if (headers instanceof Headers) {
    return new Headers(headers);
  }
  return new Headers(headers || {});
};

const normalizeBearerToken = (value) => (
  String(value || '').replace(/^Bearer\s+/i, '').trim()
);

const invalidateCurrentPageSession = (reason) => {
  const invalidation = buildAuthSessionInvalidation(getPageAuthSession(), reason);
  if (typeof window !== 'undefined' && invalidation) {
    publishAuthSessionInvalidation(window, invalidation);
  }
  invalidatePageAuthSession();
  notifyInvalidSession(reason);
};

export const apiFetch = (url, options = {}) => {
  const headers = toHeaders(options.headers);
  const token = getAuthToken();
  const suppliedAuthorizationToken = normalizeBearerToken(headers.get('Authorization'));

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  const usesPageAuthSession = Boolean(
    token
    && (!suppliedAuthorizationToken || suppliedAuthorizationToken === token)
  );

  return fetch(url, {
    ...options,
    headers,
  }).then(async (response) => {
    if (response.status === 403) {
      const body = await response.clone().json().catch(() => ({}));
      if (body?.code === 'PAYMENT_PENDING') {
        if (usesPageAuthSession && isStoredSessionTokenCurrent(token)) {
          invalidateCurrentPageSession('payment_pending');
        }
        return response;
      }
      if (
        body?.mustChangePassword
        && usesPageAuthSession
        && typeof window !== 'undefined'
        && window.location.pathname !== '/trocar-senha'
        && isStoredSessionTokenCurrent(token)
      ) {
        window.location.assign('/trocar-senha');
        return response;
      }
    }

    const shouldHandleUnauthorized = response.status === 401
      || (response.status === 400 && await response.clone().json().then(
        (body) => String(body?.error || '').toLowerCase().includes('token inválido')
          || String(body?.error || '').toLowerCase().includes('token invalido'),
        () => false
      ));

    if (shouldHandleUnauthorized) {
      if (usesPageAuthSession && isStoredSessionTokenCurrent(token)) {
        invalidateCurrentPageSession('session_invalid');
      }
    }

    return response;
  });
};

export const bridgeFetch = (url, options = {}) => {
  const headers = toHeaders(options.headers);
  const token = getAuthToken();

  if (token && !headers.has('X-Auth-Token')) {
    headers.set('X-Auth-Token', `Bearer ${token}`);
  }

  return fetch(url, {
    ...options,
    headers,
  });
};
